// @flow

// TODO: Support recursive?
export const omitNull = (obj: Object) => {
  if (
    typeof obj === 'string'
    || typeof obj === 'number'
    || typeof obj === 'boolean'
    || Array.isArray(obj)
  ) {
    throw new Error('obj arg must be an object.');
  }

  if (!obj) {
    return undefined;
  }

  return (
    Object.entries(obj)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, value]) => value !== null)
      .reduce(
        (prev, [key, value]) => ({
          ...prev,
          [key]: value,
        }),
        {},
      )
  );
};
